import React, { FC, useEffect } from "react";
import { useCountryStore } from "../../store/useCountryStore";

interface CountrySelectProps {
  country?: string;
}

const localCountries = [
   { id: "BD", name: "Bangladesh", flag: "assets/bangladesh-flag.svg" },
  { id: "IN", name: "India", flag: "assets/india-flag.svg" },
 
  { id: "LK", name: "Sri Lanka", flag: "assets/srilanka-flag.svg" }
];

const CountrySelect: FC<CountrySelectProps> = ({ country }) => {
  const { country: selectedCountry, setCountry } = useCountryStore();

  // Sync prop -> store (only when prop exists)
  useEffect(() => {
    if (country && country !== selectedCountry?.id) {
      const found = localCountries.find(c => c.id === country);
      if (found) setCountry(found);
    }
  }, [country]);

  return (
    <div className="flex flex-wrap gap-2 ">
      {localCountries.map(item => {
        const isActive = selectedCountry?.id === item.id;

        return (
          <div
            key={item.id}
            onClick={() => setCountry(item)}
            className={`
              cursor-pointer group relative
              h-10 lg:h-12 px-4 flex items-center gap-2
              rounded-lg transition-all duration-300
              border-b-2 shadow-md
              ${
                isActive
                  ? "border-green-600 bg-green-50 shadow-green-200"
                  : "border-gray-200 bg-white"
              }
            `}
          >
            {/* Flag */}
            <div className="w-6 h-4 lg:w-8 lg:h-6 rounded overflow-hidden">
              <img
                src={item.flag}
                alt={item.name}
                className="w-full h-full object-cover"
              />
            </div>

            {/* Name */}
            <span
              className={`text-xs lg:text-sm font-medium ${
                isActive ? "text-green-700" : "text-gray-600"
              }`}
            >
              {item.name}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default CountrySelect;
